import pd1Service from "@/apis/pd1/index.js";
import getUserInfo from "@/models/userInfo";

export default {
  data() {
    return {
      pd1EnumsMap: {},
      currentUserInfo: {},
    };
  },
  watch: {
    pd1EnumsMap: {
      handler(val) {
        if (val && val.expert_service_type) {
          this.init && this.init();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.getPd1Service();
    // await this.getWorkDingAuth();
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
  },
  methods: {
    getPd1Service() {
      pd1Service.pd1Enums().then((res) => {
        this.pd1EnumsMap = res;
      });
    },
  },
};
